import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'

import { media } from '../../styles/utils'
import { heading2, paragraph, caption } from '../../styles/type'
import { grey } from '../../styles/colors'
import { filter, find } from 'lodash'

const FieldCheckbox = (props) => {
	const { options, helperText } = props
	const [selected, setSelected] = useState(props.value || true)

	useEffect(() => {
		props.onChangeValue && props.onChangeValue(selected)
	}, [selected])

	const onChange = (option) => {
		setSelected(selected && selected.slug == option.slug ? false : option)
	}

	const renderOptions = () => {
		if (!options.length) return

		const items = options.map((option, i) => {
			let active = selected && selected.slug == option.slug

			return (
				<Item
					key={i}
					className={'checkbox-item'}
					active={active}
					onClick={() => {
						return onChange(option)
					}}
				>
					<Radio
						className={'checkbox-radio'}
						active={active}
					/>

					<Info>
						{option.label && (
							<Heading className={'checkbox-label'}>
								{option.label}
							</Heading>
						)}

						{option.description && (
							<Text className={'checkbox-text'}>
								{option.description}
							</Text>
						)}
					</Info>
				</Item>
			)
		})

		return (
			<Items
				className={'checkbox-items'}
			>
				{items}
			</Items>
		)
	}

	return (
		<Wrapper 
			className={'checkbox-wrapper'}
		>
			{renderOptions()}
		</Wrapper>
	)
}

// Shared

const Heading = styled.div``
const Text = styled.div``
const Info = styled.div``

// Layout

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;	 

	.error {
		margin-top: 24px;
	}
`

// Item

const Items = styled.div`
	display: flex;
	flex-direction: column;
`

const Radio = styled.div`
	width: 11px;
	height: 11px;
	min-width: 11px;
	border: 1px solid black;
	position: relative;
	margin-right: 8px;
	cursor: pointer;
	margin-top: 4px;

	${(props) => {
		if (props.active) {
			return css`
				background: black;
			`
		}
	}}
`

const Item = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	cursor: pointer;
	user-select: none;

	&:not(:last-child) {
		margin-bottom: 12px;
	}

	${Info} {
		display: flex;
		flex-direction: column;

		${Heading} {
			${paragraph}
		}
	}
`

FieldCheckbox.wrapper = css``
FieldCheckbox.displayName = 'FieldCheckbox'

export default FieldCheckbox



// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js